/**
 * GrowBar — a translucent bar behind a row that grows from the left to `pct`
 * of the row's width on mount (and glides when `pct` changes). Gives a list
 * of numbers an at-a-glance shape (e.g. EV per sportsbook). Put it as the
 * FIRST child of a row with `overflow: 'hidden'` so content paints above it.
 */
import React, { useEffect, useRef } from 'react';
import { Animated, StyleSheet } from 'react-native';
import { timing, staggerDelay, prefersReducedMotion } from '../../utils/motion';

export default function GrowBar({ pct, index = 0, color = 'rgba(74,222,128,0.10)' }) {
    const clamped = Math.max(0, Math.min(100, Number.isFinite(pct) ? pct : 0));
    const w = useRef(new Animated.Value(prefersReducedMotion() || index >= 14 ? clamped : 0)).current;

    useEffect(() => {
        const anim = timing(w, clamped, { duration: 'page', easing: 'out', delay: staggerDelay(index, 30, 240) + 80, useNative: false });
        anim.start();
        return () => anim.stop();
    }, [clamped, index, w]);

    return (
        <Animated.View
            style={[
                StyleSheet.absoluteFill,
                {
                    pointerEvents: 'none', backgroundColor: color, width: w.interpolate({ inputRange: [0, 100], outputRange: ['0%', '100%'] }) },
            ]}
        />
    );
}
